var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 591,
    viewBox: "0 0 700 591",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.325 55.4133C441.477 42.7991 413.539 50.2849 400.925 72.1334L217.002 390.697C204.388 412.545 211.874 440.482 233.723 453.097C255.571 465.711 283.509 458.225 296.123 436.377L480.045 117.813C492.659 95.965 485.174 68.0275 463.325 55.4133ZM521.516 180.623C499.668 168.008 471.73 175.494 459.116 197.343L359.341 370.158C346.727 392.006 354.213 419.944 376.061 432.558C397.909 445.172 425.847 437.687 438.461 415.838L538.236 243.023C550.85 221.174 543.364 193.237 521.516 180.623ZM244.486 112.292C257.1 90.4434 285.037 82.9575 306.886 95.5717C328.734 108.186 336.22 136.123 323.606 157.972L256.288 274.57C243.674 296.419 215.736 303.904 193.888 291.29C172.039 278.676 164.553 250.739 177.168 228.89L244.486 112.292ZM130.354 93.5927C142.968 71.7443 170.906 64.2584 192.754 76.8726C214.603 89.4868 222.088 117.424 209.474 139.273L195.049 164.258C182.435 186.107 154.497 193.592 132.649 180.978C110.8 168.364 103.314 140.427 115.929 118.578L130.354 93.5927ZM492.34 370.601C504.622 349.327 531.825 342.039 553.098 354.321C574.372 366.603 581.661 393.805 569.378 415.079C557.096 436.352 529.894 443.641 508.62 431.359C487.347 419.077 480.058 391.874 492.34 370.601Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackground);
export default __webpack_public_path__ + "static/media/logo-background.02587b6b9c6cdf31e03a3366ba7c3836.svg";
export { ForwardRef as ReactComponent };